// extracted by mini-css-extract-plugin
export default {"backLink":"Canvass_backLink__2X+MK","backIcon":"Canvass_backIcon__+VhvA","backText":"Canvass_backText__lfobZ","previewPill":"Canvass_previewPill__VRQFP"};